import uniqueId from "lodash/uniqueId";
import {
  FIELD_PARENT_ACTIVITY_KEY,
  FIELD_STATE_KEY
} from "PFApp/constants/activity_form/activity_form_field_keys";
import { useInitialRoleData } from "PFApp/hooks/activity_form/multi_roles_form/use_initial_role_data";
import { ManageRolesFormType } from "PFApp/types/activity_form/manage_roles_form_schema";
import { AvailabilityMode } from "PFCore/types";
import { AvailabilityRuleV2 } from "PFTypes/availability";

import { DRAFT_UNIQUE_ID_PREFIX } from "../manage_roles_constants";

const DEFAULT_AVAILABILITY_THRESHOLD = 70;

type GetNewDraftRoleParams = {
  subtemplateKey: string;
};

export const useNewDraftRole = () => {
  const { getInitialRoleData } = useInitialRoleData({});

  const getNewDraftRole = ({ subtemplateKey }: GetNewDraftRoleParams): ManageRolesFormType => {
    const uniqueIdString = uniqueId(DRAFT_UNIQUE_ID_PREFIX);
    const base = getInitialRoleData({ uniqueId: uniqueIdString, subtemplateKey, isNew: true });

    const availabilityThreshold =
      (base.metadata?.availability as { availability_threshold?: number } | undefined)
        ?.availability_threshold ?? DEFAULT_AVAILABILITY_THRESHOLD;

    const convertedAvailability: AvailabilityRuleV2 = {
      mode: AvailabilityMode.PerWeek,
      availabilityThreshold,
      ranges: []
    };

    return {
      ...base,
      original: {},
      [FIELD_STATE_KEY]: "draft",
      convertedAvailability,
      engagement_id: undefined,
      [FIELD_PARENT_ACTIVITY_KEY]: null,
      original_wm: [],
      booked_wm: [],
      suggested_wm: [],
      is_shortlistable: false
    } as ManageRolesFormType;
  };

  return { getNewDraftRole };
};
